import React, { useState } from "react";
import {
  Button,
  Grid,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  CircularProgress,
} from "@material-ui/core";
import { panelUsersAuthStyle } from "../../../users_auth/panelUsersAuthStyle";
import { useDispatch } from "react-redux";
import { Store } from "react-notifications-component";
import { crearAños } from "../../../domain/api/AdministracionApi";

export const Create = ({ reload, clearData }) => {
  const classes = panelUsersAuthStyle();
  const [isLoanding] = useState(false);
  const [AñoCreado, setAñoCreado] = useState("");

  const dispath = useDispatch();
  const handledAlert = (title, message, type) => {
    Store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
      },
    });

    reload();
    clearData();
  };

  const crearAño = async () => {
    const response = await crearAños(dispath, AñoCreado);

    try {
      if (response.codigo === "0000") {
        handledAlert("creado Exitosamente!", `Año  ${AñoCreado} `, "success");
      } else {
        handledAlert(
          "Ocurrio un erro!",
          "el año ya existe intente nuevamente",
          "danger"
        );
      }
    } catch {
      // handledAlert("Ocurrio un erro!", "Error intente nuevamente", "danger")
    }
  };
  const cancelar = async () => {
    clearData()
    setAñoCreado("")
  };

  return (
    <form>
      <Grid container spacing={3} style={{ textAlign: "left" }}>
        <Grid item xs={12} md={12} sm={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel htmlFor="nombre">Año</InputLabel>
            <OutlinedInput
              id="año"
              type="number"
              name="año"
              value={AñoCreado}
              required
              onChange={(e) => {
                setAñoCreado(e.target.value);
              }}
              pattern="\d{4}"
              minLength="4"
              maxLength="4"
              style={{ borderRadius: "10px" }}
              startAdornment={
                <InputAdornment position="start">-</InputAdornment>
              }
              labelWidth={100}
            />
          </FormControl>
        </Grid>
      </Grid>
      <div className={classes.wrapper}>
        <Grid container justifyContent="center" style={{ marginTop: "10px" }}>
          <div style={{ display: "flex", gap: "10px" }}>

            <Button
              disabled={!AñoCreado}
              type="button"
              variant="contained"
              color="primary"
              style={{
                textTransform: "none",
                width: "80%",
                borderRadius: '10px'
              }}
              onClick={crearAño}
            >
              Crear Año
            </Button>
            <Button
              type="button"
              variant="contained"
              color="primary"
              style={{
                textTransform: "none",
                width: "70%",
                borderRadius: '10px'
              }}
              onClick={cancelar}
            >
              Cancelar
            </Button>
          </div>
        </Grid>
        {isLoanding && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </div>
    </form>
  );
};
